/** Estados del pipeline de custodia (rol store). Coinciden con `partner_store_custody.status` en Supabase. */
export const PARTNER_CUSTODY_STATUS_ORDER = ['esperando', 'recibido', 'en_revision', 'verificado', 'listo', 'entregado'];

export const PARTNER_CUSTODY_STATUS_LABEL_ES = {
  esperando: 'Esperando',
  recibido: 'Recibido',
  en_revision: 'En revisión',
  verificado: 'Verificado',
  listo: 'Listo',
  entregado: 'Entregado',
};

/**
 * @param {string} current
 * @returns {string|null}
 */
export function partnerCustodyNextStatus(current) {
  const i = PARTNER_CUSTODY_STATUS_ORDER.indexOf(current);
  if (i < 0 || i >= PARTNER_CUSTODY_STATUS_ORDER.length - 1) return null;
  return PARTNER_CUSTODY_STATUS_ORDER[i + 1];
}
